import { DropResult } from "react-beautiful-dnd";

/**
 * Abstraction to handle onDragEnd for DragDropContext.
 * @param {DropResult} result Result passed in from the DragAndDropContext component.
 * @param {any[]} reorderedData The data that is being reordered.
 * @param {(any[]) => void} callback Logic to execute with the data after the reorder happens.
 */
export function handleOnDragEnd(
    result: DropResult,
    reorderedData: any[],
    callback: (updatedOrderData: any[]) => void,
): void {
    // If dragged out of the list area, don't update.
    if (!result.destination) {
        return;
    }
    // If left in the same position, don't update.
    if (result.destination.index === result.source.index) {
        return;
    }

    const updatedOrderData = reorder(reorderedData, result.source.index, result.destination.index);

    callback(updatedOrderData);
}

/**
 * Reorder draggable components in drag-and-drop list.
 * @param {any[]} list List of elements that is being reordered.
 * @param {number} startIndex Start position of element being reordered.
 * @param {number} endIndex End position of element being reordered.
 * @return {any[]} New array with the reordered element in it's new position.
 */
export const reorder = (list: any[], startIndex: number, endIndex: number): any[] => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};
